module.exports = __webpack_public_path__ + "img/how-video-bird.d3606ee7.png";